module.exports = __webpack_public_path__ + "img/ax.f1eeb051.svg";